import { __extends } from "tslib";
import { BaseTelemetryPlugin, extend } from '@microsoft/1ds-core-js';
import { addOneDSFields } from './InternalUtils';
var PartAPlugin = /** @class */ (function (_super) {
    __extends(PartAPlugin, _super);
    function PartAPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.identifier = 'PartAPlugin';
        // Plugins with lesser priority numbers are processed earlier.
        // Other commonly used plugins have these priorities:
        //   Properties     3
        //   WebAnalytics 180
        //   PrivacyGuard 499
        //   PostChannel 1011
        // We want PartAPlugin to happen before Privacy Guard, but after most of the other plugins.
        _this.priority = 450;
        _this._properties = {};
        return _this;
    }
    PartAPlugin.prototype.initialize = function (_coreConfig, _core, _extensions) {
        _super.prototype.initialize.call(this, _coreConfig, _core, _extensions);
    };
    /**
     * Process the event and add part A fields to it.
     * @param {object} telemetryEvent - The event that needs to be stored.
     */
    PartAPlugin.prototype.processTelemetry = function (telemetryEvent, itemCtx) {
        // Try to use Browser-optimized Object.assign if it's available.
        // The typecast to "any" is required as this package is being built with target: "es5"
        // and Object.assign requires "es2015"
        if (Object.assign) {
            Object.assign(telemetryEvent.data, this._properties);
        }
        else {
            // Fallback to slow, custom JavaScript based merging for old browsers
            telemetryEvent.data = extend(telemetryEvent.data, this._properties);
        }
        var itemContext = this._getTelCtx(itemCtx);
        this.processNext(telemetryEvent, itemContext);
    };
    /**
     * Add properties to send on every event
     * @param properties Properties to send on every event
     */
    PartAPlugin.prototype.addDataFields = function (dataFields) {
        addOneDSFields(this._properties, dataFields, {
            prependDataToken: false,
            customerContentEnabled: false
        });
    };
    return PartAPlugin;
}(BaseTelemetryPlugin));
export { PartAPlugin };
//# sourceMappingURL=PartAPlugin.js.map